"use strict";
/*jshint esversion: 11 */

import React, {Fragment, useEffect, useState} from 'react';
import {createRoot} from 'react-dom/client';
import PropTypes from "prop-types";
import CsfMembrePageHeading from "../csf-membre-page-heading/csf-membre-page-heading";
import CsfMembreSideMenu from "../csf-membre-side-menu/csf-membre-side-menu";
import { startLoadingSpinner, stopLoadingSpinner } from "../../csf-ufc-pivotal/includes/utils";
import CsfMembreDossierUfcDataLayer
  from "../dossier-ufc/CsfMembreDossierUfcDataLayer";
import CsfMembreDispenseModal from "./CsfMembreDispenseModal";
import CsfMembreDispenseDeleteModal from "./CsfMembreDispenseDeleteModal";
import CsfMembreDispenseConfirmationModal from "./CsfMembreDispenseConfirmationModal";
import CsfMembreDispensesDataLayer from "./CsfMembreDispensesDataLayer";
import {
  handleFileInput
} from '../../csf-ufc-fournisseur/includes/utils';
import CsfMemberDataLayer from "../utils/CsfMembreDataLayer";

import CsfMembreDispenseListItemUploads
  from "./CsfMembreDispenseListItemUploads";

export function CsfMembreDispenses({apiUrl, apiEnv, urlDossierUfc, urlNotifications}) {
  const [isError, setIsError] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [memberInfo, setMemberInfo] = useState({});
  const [memberContactInfo, setMemberContactInfo] = useState(null);
  const [checkedPrintOption, setCheckedPrintOption] = useState('');
  const [dataLayer, setDataLayer] = useState({});
  const [dispensesDataLayer, setDispensesDataLayer] = useState({});
  const [dispensesList, setDispensesList] = useState([]);
  const [educationFileId, setEducationFileId] = useState(null);
  const [modalExemptionItem, setModalExemptionItem] = useState(null);
  const [shouldEmptyModal, setShouldEmptyModal] = useState(false);

  /*
  * Call this method when an api error occurs.
  * */
  function apiErrorCallback(errorMessage) {
    setIsError(true);
    stopLoadingSpinner();
    console.error(errorMessage);
  }

  useEffect(() => {
    startLoadingSpinner();
    CsfMemberDataLayer.fetchAccessToken(setAccessToken);
    handleFileInput();

    // Add modal close listener to reset fields
    $('#membreDispenseModal').on('hidden.bs.modal', handleModalReset);
  }, []);

  useEffect(() => {
    if (accessToken) {
      const dataObj = new CsfMembreDossierUfcDataLayer(apiUrl, apiEnv, accessToken);
      dataObj.fetchMemberInfo(setMemberInfo);
      setDataLayer(dataObj);
    }
  }, [accessToken]);

  useEffect(() => {
    if (accessToken && dataLayer?.isInit && memberInfo?.Contact_Id) {
      const dispensesService = new CsfMembreDispensesDataLayer(apiUrl, apiEnv, accessToken);
      dispensesService.fetchMemberContactInfo(memberInfo.Contact_Id, setMemberContactInfo);
      setDispensesDataLayer(dispensesService);
    }
  }, [accessToken, memberInfo]);

  useEffect(() => {
    if (dispensesDataLayer?.isInit && memberContactInfo) {

      if (memberContactInfo?.Education_File__Secondary?.length) {
        const fileSecondaryData = memberContactInfo?.Education_File__Secondary[0];
        let eduFileId = '';
        if (fileSecondaryData?.Education_File_Id !== null) {
          eduFileId = fileSecondaryData?.Education_File_Id;
        } else {
          // fallback pour anciens dossiers
          eduFileId = fileSecondaryData?.REDU_Education_File_Id;
        }
        dispensesDataLayer.fetchExemptions(eduFileId, setDispensesList);
        setEducationFileId(eduFileId);
      }

    }
  }, [dispensesDataLayer, memberContactInfo]);

  /*
  * Init the bootstrap tooltips on list change
  * */
  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip({
      customClass: 'sup-tooltip'
    });
  }, []);

  function handleModalReset() {
    setModalExemptionItem(null);
    setShouldEmptyModal(true);
  }

  return (
    <main className="membre dispenses">

      <div className="content">
        <div className="primary non-print-wrapper">
          <section className="dispenses__top-section primary-bg mb-5 py-5">
            <p className="text-bold mb-2 text-primary">Important</p>
            <p className="text-primary">{window.Drupal.t('membre.dispense.warning.firstParagraph')}</p>
            <div className="d-flex gap-4 flex-wrap flex-md-nowrap align-items-end justify-content-between mt-6">
              <div dangerouslySetInnerHTML={{__html: window.Drupal.t('membre.dispense.warning.secondParagraph')}}></div>
              <button type="button"
                      className='button btn-pale btn-larger flex-shrink-0'
                      data-toggle="modal"
                      data-target="#membreDispenseModal"
                      onClick={() => {setModalExemptionItem(null);}}
              >
                {window.Drupal.t('membre.dispense.btn.new.label')}
              </button>
            </div>
          </section>

          {/* main section */}
          <section className="primary-bg">

            {/* sub title */}
            <CsfMembrePageHeading
              title={window.Drupal.t('membre.dispense.title')}
              memberName={memberInfo["Prénom"] + ' ' + memberInfo["Nom"]}
              certificatNumber={memberInfo["No_Dossier"]}
            />

            {isError && (
              <div className="alert alert-danger mb-4" role="alert"
                  aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
            )}

            <div className="inner-wrapper">
              <div className="table-wrapper">
              <table className="dispenses__table">
                  <thead>
                    <tr>
                      <th colSpan="2">
                        {window.Drupal.t('Start date')}
                      </th>
                      <th>
                        {window.Drupal.t('End date')}
                      </th>
                      <th>
                        {window.Drupal.t('membre.dispense.reason')} <img className="ml-1" src="/themes/custom/tink/dist/assets/icon-membre-tooltip.svg" data-toggle="tooltip"
                        title="tooltip en question" alt="Tooltip icon" />
                      </th>
                      <th width="114">
                        {window.Drupal.t('membre.dispense.entryDate')}
                      </th>
                      <th width="114">
                        {window.Drupal.t('membre.dispense.processingDate')}
                      </th>
                      <th width="196">
                        {window.Drupal.t('State')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>

                    { dispensesList?.length === 0 ? (
                      <tr>
                        <td colSpan="7">
                          <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
                        </td>
                      </tr>
                    ): (<></>) }
                      { dispensesList.map(item => (
                        <Fragment key={item.REDU_Exemption_Id}>
                          <tr className="dispenses__base-info">
                            <td width="24" className="pr-0">
                              { (item && CsfMembreDispensesDataLayer.isEditableDispense(item.REDU_Chrono_Followup_Type_Id)) && (
                              <button type="button"
                                      className='button btn-outlined btn-icon-only'
                                      title={window.Drupal.t('Edit')}
                                      data-toggle="modal"
                                      data-target="#membreDispenseModal"
                                      onClick={() => {setModalExemptionItem(item);}}>
                                <i className="icon icon-csf-edit supplier-icon"><span className="d-none">&nbsp;</span></i>
                              </button>
                              )}
                            </td>
                            <td>
                              { CsfMembreDispensesDataLayer.getFormattedDispenseDate(item.Start_Date) }
                            </td>
                            <td>
                              { CsfMembreDispensesDataLayer.getFormattedDispenseDate(item.End_Date)  }
                            </td>
                            <td>
                              { CsfMembreDispensesDataLayer.getReasonDescriptionFromCode(item.Reason) }
                            </td>
                            <td>
                              { CsfMembreDispensesDataLayer.getFormattedDispenseDate(item.Received_Date)  }
                            </td>
                            <td>
                              { CsfMembreDispensesDataLayer.getFormattedDispenseDate(item.Treatment_Date)  }
                            </td>
                            <td className="d-flex justify-content-between align-items-center">
                              <span className={CsfMembreDispensesDataLayer.getDispenseStatusCssClasses(item.REDU_Chrono_Followup_Type_Id)}>
                                {item.REDU_Chrono_Followup_Type_Id__Rn_Descriptor}
                              </span>
                              <button className="dispenses__table-accordion"
                                type="button" data-toggle="collapse"
                                data-target={`#${item.REDU_Exemption_Id.replace('=', '')}__content`} aria-expanded="false"
                                aria-controls={`${item.REDU_Exemption_Id.replace('=', '')}__content`}
                                aria-label={`${CsfMembreDispensesDataLayer.getReasonDescriptionFromCode(item.Reason)} - ${window.Drupal.t('membre.summary.detail.aria-label')}`}>
                                <img className="img-arrow"
                                  src="/themes/custom/tink/dist/assets/chevron-left.svg" alt="chevron"/>
                              </button>
                            </td>
                          </tr>
                          <tr className="dispenses__more-info">
                            <td colSpan="7" className="p-0">
                              <div id={`${item.REDU_Exemption_Id.replace('=', '')}__content`} className="accordion-collapse collapse">
                                <p>
                                  {item.REDU_Comment}
                                </p>

                                <CsfMembreDispenseListItemUploads
                                  educationFileId={educationFileId}
                                  exemptionItem={item}
                                  dispenseDataService={dispensesDataLayer}
                                  apiUrl={apiUrl}
                                  apiEnv={apiEnv}
                                  accessToken={accessToken}
                                />
                              </div>
                            </td>
                          </tr>
                        </Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>

        <CsfMembreDispenseModal educationFileId={educationFileId}
                                exemptionItem={modalExemptionItem}
                                dispenseDataService={dispensesDataLayer}
                                apiUrl={apiUrl}
                                apiEnv={apiEnv}
                                accessToken={accessToken}
                                shouldEmptyModal={shouldEmptyModal}
                                setShouldEmptyModal={setShouldEmptyModal}
        />
        <CsfMembreDispenseDeleteModal
          exemptionItem={modalExemptionItem}
          dispenseDataService={dispensesDataLayer}
        />
        <CsfMembreDispenseConfirmationModal />

        {/* aside section */}
        <CsfMembreSideMenu
          apiUrl={apiUrl}
          apiEnv={apiEnv}
          urlDossierUfc={urlDossierUfc}
          urlNotifications={urlNotifications}
          checkedPrintOption={checkedPrintOption}
          setCheckedPrintOption={setCheckedPrintOption}
        />

      </div>

    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfMembreDispenses');


  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const urlDossierUfc = domNode.getAttribute("data-urlSectionMembreDossierUfc");
    const urlNotifications = domNode.getAttribute("data-urlSectionMembreNotifications");

    root.render(<CsfMembreDispenses
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      urlDossierUfc={urlDossierUfc}
      urlNotifications={urlNotifications}
    />);
  }
});

CsfMembreDispenses.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  urlDossierUfc: PropTypes.string,
  urlNotifications: PropTypes.string,
};
